/* eslint-disable react/forbid-prop-types */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import InvoiceQuarterTab from './invoiceQuarterTab';
import {
  currencyFormatter,
  redirectURLLink,
  checkQuarterValidation,
  closeTab,
  redirectNewCombination,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import InvoiceOtherQuarterTab from './invoiceOtherQuarterTab';
import InvoiceQuarterTotalsTab from './invoiceQuarterTotalsTab';
import MailingTab from './mailingTab';
import {
  getInvoiceQuarter,
  getInvoiceOtherQuarter,
  setCheckLogOpen,
  getCheckLogByInvoiceNum,
  getBlanceCode,
  setDisplayInvoiceObj,
  setTabDetails,
  dispatchInvoiceQuarter,
  dispatchInvoiceOtherQuarter,
  dispatchInvoiceQuarterTotals,
  setInvoiceOtherQtrIndex,
  setInvoiceOtherSelectedQtr,
} from '../store/actions';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import ErrorPopup from '../../NDC/component/ErrorPopup';
import {
  fetchAllManufacturerDetail,
  getContactDetails,
  maintainLabelerListData,
  setMaintainManufacturerTab,
  setSelectManufacturerData,
} from '../../../Maintain/Manufacturer/store/ManufacturerAction';
import {
  dispatchCellClick,
  selectedType,
} from '../../../Maintain/Contract/store/actions';
import { getRebatePgmDetail } from '../../../Maintain/RebateProgram/SearchRebate/store/actions';
import { tabValue } from '../../../Maintain/RebateProgram/MaintainRebate/store/actions';
import {
  dispatchFindNDCLevelDetails,
  dispatchNDCAuditDes,
  dispatchPagValue,
  getFindNDCLevelDetailList,
  getNDCAuditDescription,
  getSearchInvoiceByCriteriaList,
  postSaveOrUpdate,
  setInvoiceAuditDetailTab,
  setPervSearchInvoiceRedux,
  setSearchScreenTab,
} from '../../../Research/InvoiceAudits/store/Actions';
import InvoiceChecksLog from './invoiceChecksLog';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import { getgeneralsystemparameterDetails } from '../../../System/systemParameter/store/actions';
import {
  filterSelectByList,
  tableGridHight350,
  radioGroupLabelNamePlan,
  rebateProgramLabelName,
  quarterLabelName,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  setErrorMessageForSearch,
  dispatchActiveInvoiceNumber,
  getManufacturerList,
  getRosiAllocatePaymentDetail,
  dispatchManufacturerData,
  getRebateProgramDropdownList,
  dispatchExistingInvoiceNumCheck,
  getQuarterData,
  getExistingInvoiceNumCount,
  getPlanTypeRadioBoxValue,
  setSearchPickInvoiceAssScreenTab,
  dispatchFailedAPIError,
  handleErrorMessageForAllocatePayment,
  clearReduxAllocatePaymentThirdScreen,
  setPerviousScreenReduxData,
  dispatchAllocatePaymentHederData,
} from '../../../Tasks/AllocatePayments/store/Actions';
import {
  dispatchNoPaySuspended,
  dispatchSaveDetailsResponse,
} from '../../../Tasks/AllocatePayments/PQASTab/store/Actions';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import {
  autoFormateDate,
  tabHighLigther,
  checkActionAccessByRole,
} from '../../../../SharedModules/utilities/utilities';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { getAllocatePaymentScreenData } from '../../../Tasks/AllocatePayments/components/gridComponents/ROSIUtils';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  input: {
    color: 'red !important',
  },
}));

const Action = ({ data }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [error, setError] = useState(null);
  const [showAuditModal, setShowAuditModal] = useState(false);

  const searchContractState = useSelector(
    (state) => state.sharedState?.ContractReducer?.searchContractState
  );

  const searchInvoiceAuditTabData = useSelector(
    (state) => state.sharedState.InvoiceAuditsReducer.searchInvoiceAuditObj
  );

  const handleViewDetailFunction = async () => {
    const payload = {
      auditType: 'ALL',
      rebateProgramCode: data?.rebateProgramCd,
      quarter: data?.qtr,
      clearedIndex: 0,
      unclearedIndex: 1,
      asCode: 'A',
    };
    const resultData = await dispatch(getSearchInvoiceByCriteriaList(payload));
    const response = resultData && resultData.searchInvoiceByCriteriaList;
    if (
      response &&
      response.invoiceAuditGridResponse2 &&
      response.invoiceAuditGridResponse2.length > 0
    ) {
      setShowAuditModal(false);
      dispatch(dispatchFindNDCLevelDetails([]));
      dispatch(dispatchNDCAuditDes([]));
      dispatch(setInvoiceAuditDetailTab({}));
      dispatch(getFindNDCLevelDetailList([], 'update'));
      dispatch(getNDCAuditDescription([], 'update'));
      dispatch(dispatchPagValue(1));
      dispatch(postSaveOrUpdate(null));
      dispatch(setPervSearchInvoiceRedux(response));
      dispatch(setSearchScreenTab(searchInvoiceAuditTabData));
      redirectURLLink(
        '/invoiceAuditsDetail',
        'Invoice Audits Detail',
        history,
        dispatch
      );
    } else {
      setShowAuditModal(true);
    }
  };
  const handleLinkButton = async (e) => {
    if (e.target.name === 'Go To ROSI/PQAS') {
      const response = await dispatch(
        getCheckLogByInvoiceNum(data?.invoiceNum)
      );
      if (response?.payload.data?.length === 1) {
        dispatch(setCheckLogOpen(false));
        sessionStorage.setItem('singlecheckdata', true);
      } else {
        dispatch(setCheckLogOpen(true));
      }
    } else if (e.target.name === 'Go To Contract') {
      dispatch(dispatchCellClick(true));
      dispatch(selectedType('C'));
      searchContractState.contractType = 'onSelect';
      searchContractState.selectedContractType = 'contractId';
      searchContractState.selectedRowData = data?.contractSeqNum;
      searchContractState.selectedContractId = data?.contractSeqNum;
      searchContractState.rebateProgramCode = data?.rebateProgramCd;
      redirectURLLink(
        '/createContract',
        'Maintain Contract',
        history,
        dispatch
      );
    } else if (e.target.name === 'Go To Manufacturer') {
      dispatch(
        setSelectManufacturerData({
          mfgId: data?.mfgId,
          mfgTypeCd: 'C',
          updateManufacturer: true,
        })
      );
      dispatch(fetchAllManufacturerDetail(null));
      dispatch(getContactDetails(null));
      dispatch(maintainLabelerListData({}));
      dispatch(setMaintainManufacturerTab({}));
      redirectURLLink(
        '/manufacturer-detail',
        'Maintain Manufacturer',
        history,
        dispatch
      );
    } else if (e.target.name === 'Go To Rebate Program') {
      const request = {
        planType: data?.planTypeCode,
        rebateProg: data?.rebateProgramCd,
      };
      dispatch(getRebatePgmDetail(request));
      dispatch(tabValue('one'));
      redirectURLLink(
        '/maintainRebate',
        'Maintain Rebate Program',
        history,
        dispatch
      );
    } else if (e.target.name === 'Go To Invoice Audits') {
      handleViewDetailFunction();
    } else {
      redirectURLLink('/Wip', 'Work In Progress', history);
    }
  };

  return data ? (
    <>
      <CommonModal
        data-testid="invoice-audits-common-modal"
        open={showAuditModal}
        viewAction
        viewHeader
        onClose={() => setShowAuditModal(false)}
        onOk={() => setShowAuditModal(false)}
        okTitle="Ok"
        modalTitle="Display Invoice Audits"
        childrenComponent="This invoice does not have audits to display"
        className="dialog-420"
      />
      <Dropdown className="icon-dropdown-container">
        <Dropdown.Toggle className="icon-dropdown" aria-label="Dropdown">
          <SVGComponent iconName="Export-icon" />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item name="Go To ROSI/PQAS" onClick={handleLinkButton}>
            Go to ROSI/PQAS
          </Dropdown.Item>
          <Dropdown.Item name="Go To Invoice Audits" onClick={handleLinkButton}>
            Go to Invoice Audits
          </Dropdown.Item>
          <Dropdown.Item name="Go To Contract" onClick={handleLinkButton}>
            Go to Contract
          </Dropdown.Item>
          <Dropdown.Item name="Go To Manufacturer" onClick={handleLinkButton}>
            Go to Manufacturer
          </Dropdown.Item>
          <Dropdown.Item name="Go To Rebate Program" onClick={handleLinkButton}>
            Go to Rebate Program
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      <ErrorPopup
        modalTitle="Display Invoice"
        errorPopupMessage={error}
        onClose={() => setError(null)}
      />
    </>
  ) : (
    <></>
  );
};

export default function InvoiceTabs(props) {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    invoiceDetailsByInvoiceNum,
    handlingCodeValues,
    handleInvoiceChangeValues,
    fullScreenView,
    setFullScreenView,
    tabFullScreenView,
    setTabFullScreenView,
    ccCommentsExist,
    commonDropdownList,
    invoiceReasonList,
  } = props;

  const isCheckLogOpen = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer.isCheckLogOpen
  );
  const searchScreenTabData = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer?.pervSearchScreenData
  );
  const checkLogDetails = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer.checkLogDetails
  );
  const saveRequestData = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer.saveRequestData
  );
  const displayInvoiceObj = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer.displayInvoiceObj
  );
  const invoiceQuarter = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer.invoiceQuarter
  );
  const activeScreenDetails = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer.activeDetailScreenTabs
  );

  const invoiceOtherQuarter = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer.invoiceOtherQuarter
  );
  const balanceStatusCodeValues = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer.balanceStatusCodeValues
  );
  const defForgiveReqCommentInd = useSelector(
    (state) =>
      state?.sharedState?.SystemProviderReducer?.generalSystemParameter
        ?.paramGeneralVO?.[0]?.defForgiveReqCommentInd
  );
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);

  const [isEnablebyRole, setIsEnablebyRole] = useState(
    !checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );
  const [value, setValue] = useState(displayInvoiceObj?.tabValue || 0);

  const [typeCode, setTypeCode] = useState('');
  useEffect(() => {
    if (invoiceDetailsByInvoiceNum?.currInEffectInd == 1) {
      dispatch(getBlanceCode('BALANCE_TYPE_CD'));
    }
  }, [invoiceDetailsByInvoiceNum]);
  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        !checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);

  useEffect(() => {
    const balanceCode = invoiceDetailsByInvoiceNum?.balanceTypeCd;
    if (balanceCode) {
      for (let i = 0; i < balanceStatusCodeValues.length; i++) {
        if (
          balanceStatusCodeValues[i]?.codeValueID?.codeValue === balanceCode
        ) {
          setTypeCode(balanceStatusCodeValues[i].shortDescription);
        }
      }
      // balanceStatusCodeValues?.forEach((item) => {
      //   if (item?.codeValueID?.codeValue === balanceCode) {
      //     setTypeCode(item.shortDescription);
      //   }
      // });
    }
  }, [balanceStatusCodeValues]);

  useEffect(() => {
    dispatch(dispatchInvoiceQuarter([]));
    dispatch(dispatchInvoiceOtherQuarter([]));
    dispatch(dispatchInvoiceQuarterTotals([]));
    dispatch(setInvoiceOtherQtrIndex(0));
    dispatch(setInvoiceOtherSelectedQtr(''));
    setValue(0);
    dispatch(setDisplayInvoiceObj({ tabValue: 0 }));
    if (invoiceDetailsByInvoiceNum?.invoiceNum) {
      dispatch(
        getInvoiceQuarter({
          invoiceNum: invoiceDetailsByInvoiceNum?.invoiceNum,
          planTypeCode: invoiceDetailsByInvoiceNum?.planTypeCode,
        })
      );
      dispatch(
        getInvoiceOtherQuarter({
          qtr: invoiceDetailsByInvoiceNum?.qtr,
          mfgId: invoiceDetailsByInvoiceNum?.mfgId,
          rebateProgramCd: invoiceDetailsByInvoiceNum?.rebateProgramCd,
          invoiceReasonCd: 'CR',
          invoiceNum: invoiceDetailsByInvoiceNum?.invoiceNum,
        })
      );
    }
    const currentTabs = JSON.parse(localStorage.getItem('tabItemsData')) ?? [];
    if (!currentTabs.some((tab) => tab.navTo === '/systemparameter')) {
      dispatch(getgeneralsystemparameterDetails());
    }
  }, [invoiceDetailsByInvoiceNum?.invoiceNum]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    dispatch(
      setDisplayInvoiceObj({
        tabValue: newValue,
      })
    );
  };

  const handleClose = () => {
    dispatch(setCheckLogOpen(false));
  };

  const handleFullScreenView = (view) => {
    if (view) {
      setFullScreenView(false);
      setTabFullScreenView(view);
    } else {
      setTabFullScreenView(view);
    }
  };
  // use Selector function
  const fetchSearchScreenData = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer?.pervSearchScreenData
  );
  const searchPickInvAssociateScreenObj = useSelector(
    (state) =>
      state.sharedState.AllocatePaymentReducer?.searchPickInvAssociateScreenObj
  );
  const errorMessagesFromRedux = useSelector(
    (state) =>
      state?.sharedState?.AllocatePaymentReducer
        ?.searchPickInvoiceAssScreenErrors
  );

  const invoiceNumberStatus = useSelector(
    (state) => state?.sharedState?.AllocatePaymentReducer?.invoiceNumCount
  );
  const tabDetails = useSelector(
    (state) => state?.sharedState?.DisplayInvoiceReducer?.tabDetails
  );
  const activeInvoiceNumArray = useSelector(
    (state) => state?.sharedState?.AllocatePaymentReducer?.activeInvoiceNum
  );
  const UserDefaultValues = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const fetchManufacturerList = useSelector((state) =>
    state.sharedState.AllocatePaymentReducer?.manufacturerList?.sort(
      (a, b) => a.mfgId - b.mfgId
    )
  );
  const getQuarterDataValue = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer.quarter
  );
  const AllocatePaymentReducer = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer
  );
  const headerAllocatePaymentData = useSelector(
    (state) =>
      state.sharedState.AllocatePaymentReducer?.headerAllocatePaymentData
  );

  // variable deceleration
  const gridRef = React.useRef();
  const [gridParams, setGridParams] = React.useState(null);
  const [planTypeOptions, setPlanTypeOptions] = React.useState([]);
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [selectedRow, setSelectedRow] = React.useState({});
  const [warningAlert, setWarningAlert] = React.useState(false);
  const [warningMessage, setWaringMessage] = React.useState('');
  const [modalTitle, setModalTitle] = React.useState('');
  const [alreadyExistInvoiceNum, setAlreadyExistInvoiceNum] =
    React.useState(false);
  const [values, setValues] = React.useState(
    searchPickInvAssociateScreenObj?.values
      ? searchPickInvAssociateScreenObj?.values
      : {
          selectedBy: UserDefaultValues?.defInvoiceSelectModeCd
            ? UserDefaultValues?.defInvoiceSelectModeCd
            : 'PQM',
          planTypeCd: UserDefaultValues?.planTypeCd
            ? UserDefaultValues?.planTypeCd
            : 'FD',
          rebateProgramCd: UserDefaultValues?.rebateProgramCd
            ? UserDefaultValues?.rebateProgramCd
            : '-1',
          quarterValue: null,
          invoiceNum: '',
        }
  );
  // handling onPage load call service
  React.useEffect(() => {
    dispatch(dispatchFailedAPIError(null));
  }, []);

  // set common dropdown list after calling API service
  React.useEffect(() => {
    getRebateProgramDropdownList(values?.planTypeCd).then((res) => {
      let list = [];
      if (
        res?.status === constantMessageData.STATUS_MSG &&
        res?.message === constantMessageData.SUCCESS_MSG
      ) {
        if (!_.isEmpty(res.data)) {
          list = _.map(res.data, (val) => ({
            ...val,
            id: val.rebateProgramCd,
            name: `${val.rebateProgramCd} | ${val.shortDescr}`,
          }));
        }
      }
      setRebateProgramList(
        list.sort((key, val) =>
          key.name.toLowerCase().localeCompare(val.name.toLowerCase())
        )
      );
    });
  }, [values?.planTypeCd]);

  // set initial quarte Value
  React.useEffect(() => {
    if (Object.keys(searchPickInvAssociateScreenObj)?.length === 0) {
      if (
        getQuarterDataValue &&
        !searchPickInvAssociateScreenObj?.values?.quarterValue
      ) {
        setValues({
          ...values,
          quarterValue: getQuarterDataValue
            ? autoFormateDate(getQuarterDataValue?.toUpperCase())
            : '',
        });
        dispatch(
          setSearchPickInvoiceAssScreenTab({
            ...searchPickInvAssociateScreenObj,
            values: {
              ...values,
              quarterValue: autoFormateDate(getQuarterDataValue?.toUpperCase()),
            },
          })
        );
      }
    }
  }, [getQuarterDataValue]);

  // handing highlight tab
  React.useEffect(() => {
    if (errorMessagesFromRedux?.length > 0) {
      tabHighLigther('/display-invoice', true);
    } else {
      tabHighLigther('/display-invoice', false);
    }
  }, [JSON.stringify(errorMessagesFromRedux)]);

  // redirect allocate payment detail screen

  const handleRedirectURLtoDetailScreen = async (row) => {
    const localErr = errorMessagesFromRedux || [];
    const invoiceNumber = invoiceDetailsByInvoiceNum?.invoiceNum;
    const newObj = activeInvoiceNumArray || [];
    newObj.push({
      index: newObj.length,
      invoiceNum: invoiceNumber,
      checkLogNum: row?.checkLogNum,
      active: true,
    });
    dispatch(dispatchActiveInvoiceNumber(newObj));
    const searchScreenData = fetchSearchScreenData?.selectedRow;
    const resultData = await dispatch(
      getRosiAllocatePaymentDetail({
        invoiceNum: invoiceNumber,
        checkLogNum: row?.checkLogNum,
        checkPayeeCD: row?.checkPayeeCd,
        checkAmt: row?.checkAmt,
        mfgId: invoiceDetailsByInvoiceNum?.mfgId,
        planType: invoiceDetailsByInvoiceNum?.planTypeCode,
      })
    );
    const data = resultData?.headerAllocatePaymentData;
    const headerAllocatePaymentVO =
      resultData?.headerAllocatePaymentData?.headerAllocatePaymentVO;
    if (
      headerAllocatePaymentVO &&
      Object.keys(headerAllocatePaymentVO)?.length > 0
    ) {
      getAllocatePaymentScreenData(
        data,
        dispatch,
        AllocatePaymentReducer,
        history,
        newObj,
        'displayInvoice'
      );
    }

    dispatch(setErrorMessageForSearch([...new Set(localErr)]));
  };
  // after call exIsting invoice number available on DB or not
  React.useEffect(() => {
    let localErr = errorMessagesFromRedux || [];
    if (parseInt(invoiceNumberStatus, [0, 1]) === 1) {
      dispatch(dispatchExistingInvoiceNumCheck(''));
      localErr = localErr.filter(
        (item) =>
          item.field !== 'noInvoiceNumExist' &&
          item.field !== 'resultNotFound' &&
          item.field !== 'resultNotFound1' &&
          item.field !== 'InvNumNotFrozen'
      );
      handleRedirectURLtoDetailScreen();
    } else if (parseInt(invoiceNumberStatus, [0, 1]) === 0) {
      dispatch(dispatchExistingInvoiceNumCheck(''));
      localErr = localErr.filter(
        (item) =>
          item.errorType !== 'invoiceNum' &&
          item.field !== 'resultNotFound' &&
          item.field !== 'resultNotFound1' &&
          item.field !== 'InvNumNotFrozen'
      );
      localErr.push({
        field: 'noInvoiceNumExist',
        errorType: 'invoiceNum',
        message: `${constantMessageData.NO_INVOICE_NUMBER_EXIST} (# ${values?.invoiceNum}) .`,
      });
    }
    dispatch(setErrorMessageForSearch([...new Set(localErr)]));
  }, [invoiceNumberStatus]);
  // check validation function
  const validateRequest = () => {
    let localErr = errorMessagesFromRedux || [];
    let checkValidation = false;
    if (values.rebateProgramCd === null || values.rebateProgramCd === '-1') {
      checkValidation = true;
      localErr = localErr?.filter((item) => item.filed !== 'resultNotFound2');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: constantMessageData.REBATE_PROGRAM_REQUIRED,
      });
    }
    if (values.quarterValue === '') {
      checkValidation = true;
      localErr = localErr.filter(
        (item) => item.field !== 'quarter' && item.filed !== 'resultNotFound2'
      );
      localErr.push({
        field: 'quarter',
        errorType: 'required',
        message: constantMessageData.QUARTER_VALUE_REQUIRED,
      });
    } else if (!checkQuarterValidation(values.quarterValue)) {
      checkValidation = true;
      localErr = localErr.filter(
        (item) => item.field !== 'quarter' && item.filed !== 'resultNotFound2'
      );
      localErr.push({
        field: 'quarter',
        errorType: 'invalidFormat',
        message: constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI,
      });
    }

    dispatch(setErrorMessageForSearch([...new Set(localErr)]));
    return !checkValidation;
  };
  // handle associate With check button onClick event after call
  const handleAssociateWithCheck = (row) => {
    let localErr = errorMessagesFromRedux || [];
    localErr = localErr?.filter((x) => x.errorType !== 'noRowSelected');
    if (values?.selectedBy === 'IN') {
      if (values?.invoiceNum === null || values?.invoiceNum === '') {
        localErr = [];
        localErr.push({
          field: 'resultNotFound1',
          errorType: 'invoiceNum',
          message: constantMessageData.EMPTY_INVOICE_NUMBER,
        });
      } else {
        localErr = localErr?.filter((x) => x.errorType !== 'invoiceNum');
        dispatch(dispatchExistingInvoiceNumCheck(''));
        dispatch(
          getExistingInvoiceNumCount({
            invoiceNum: values?.invoiceNum,
          })
        );
      }
    }
    if (values?.selectedBy === 'PQM') {
      handleRedirectURLtoDetailScreen(row);
    }

    dispatch(setErrorMessageForSearch([...new Set(localErr)]));
  };

  const [invoiceNumberDetail, setInvoiceNumberDetail] = useState({});
  const sendData = (data) => {
    setInvoiceNumberDetail(data);
  };
  React.useEffect(() => {
    if (invoiceNumberDetail) {
    }
  }, [invoiceNumberDetail]);
  useEffect(() => {
    if (checkLogDetails?.data?.length == 1) {
      if (sessionStorage.getItem('singlecheckdata') == 'true') {
        gotoRosiPqas();
        sessionStorage.setItem('singlecheckdata', false);
      }
    }
  }, [checkLogDetails]);

  const updateDetailsAllData = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer?.updateDetails
  );
  const hasUnsavedChangesFor = React.useCallback(
    (invoiceNum, checkNum, tabObj) => {
      if (!invoiceNum || !checkNum) return false;
      const detailKey = `${invoiceNum}-${checkNum}`;
      const detailState = updateDetailsAllData?.[detailKey];
      return tabObj?.isFormDirty || detailState?.flag === false;
    },
    [updateDetailsAllData]
  );
  const gotoRosiPqas = async () => {
    dispatch(setCheckLogOpen(false));
    const newObj = [];
    const InvNumber = invoiceDetailsByInvoiceNum?.invoiceNum;
    const CheckLogNumber =
      checkLogDetails?.data?.length == 1
        ? checkLogDetails?.data[0]?.checkLogNum
        : invoiceNumberDetail.checkLogNum;
    const isSameInvDiffCheck = activeScreenDetails?.find(
      (item) =>
        item.invoiceNumber.toString() === InvNumber.toString() &&
        item.checkNumber.toString() !== CheckLogNumber.toString()
    );
    newObj.push({
      index: newObj.length,
      invoiceNum: InvNumber,
      checkLogNum: CheckLogNumber,
      active: true,
    });

    // Check for unsaved changes

    dispatch(
      setPerviousScreenReduxData({
        ...searchScreenTabData,
        state: {
          ...searchScreenTabData.state,
          allocateFrom: 'Check',
        },
        selectedRow: { ...checkLogDetails?.data[0], checkPayeeCdVal: 'MD' },
      })
    );
    const resultData = await dispatch(
      getRosiAllocatePaymentDetail({
        invoiceNum: InvNumber,
        checkLogNum: CheckLogNumber,
        checkPayeeCD: 'MD',
        checkAmt: invoiceDetailsByInvoiceNum?.totInformationalAmt || 0,
        mfgId: invoiceDetailsByInvoiceNum?.mfgId,
        planType: invoiceDetailsByInvoiceNum?.rebateProgramCd,
      })
    );

    if (isSameInvDiffCheck && !alreadyExistInvoiceNum) {
      setModalTitle(
        `Pick an Invoice to Associate with this Check  (${CheckLogNumber})`
      );
      setAlreadyExistInvoiceNum(true);
      // setWarningAlert(true);
      setWaringMessage(constantMessageData.ALREADY_EXIST_INVOICE_NUM_NAV);
      window.existingTabToClose = {
        checkNumber: isSameInvDiffCheck.checkNumber,
        invoiceNumber: isSameInvDiffCheck.invoiceNumber,
        tabId: `ROSI/PQAS [#${isSameInvDiffCheck.invoiceNumber}] Check Log #${isSameInvDiffCheck.checkNumber}`,
        navTo: `/allocatePaymentDetail/${isSameInvDiffCheck.checkNumber}-${isSameInvDiffCheck.invoiceNumber}`,
        hasUnsavedChanges: hasUnsavedChangesFor(
          isSameInvDiffCheck.invoiceNumber,
          isSameInvDiffCheck.checkNumber,
          updateDetailsAllData?.[
            `${isSameInvDiffCheck.invoiceNumber}-${isSameInvDiffCheck.checkNumber}`
          ]
        ),
        newTarget: {
          checkNumber: CheckLogNumber,
          invoiceNumber: InvNumber, // Fixed: was 'invoiceNUmber'
          mfgId: invoiceDetailsByInvoiceNum?.mfgId,
          planType: invoiceDetailsByInvoiceNum?.rebateProgramCd,
        },
      };
      return;
    }

    const data = resultData?.headerAllocatePaymentData;
    console.log(
      headerAllocatePaymentData,
      'afterrr invoicetab first func apiiiii'
    );
    const headerAllocatePaymentVO =
      resultData?.headerAllocatePaymentData?.headerAllocatePaymentVO;
    const headerLength =
      headerAllocatePaymentVO && Object.keys(headerAllocatePaymentVO)?.length;
    if (headerLength !== undefined && headerLength > 0) {
      dispatch(dispatchActiveInvoiceNumber(newObj));
      dispatch(setTabDetails(headerAllocatePaymentData));
      getAllocatePaymentScreenData(
        data,
        dispatch,
        AllocatePaymentReducer,
        history,
        newObj
      );
    } else if (data?.forzenCase) {
      setWarningAlert(true);
      setModalTitle('Warning');
      setWaringMessage(constantMessageData.INVOICE_NUMBER_NOT_FROZEN);
    } else if (data?.noCheckPayeeForInvoice) {
      setWarningAlert(true);
      setModalTitle('Warning');
      setWaringMessage(constantMessageData.CHECK_PAYEE_CODE_INV_NUMBER_MSG);
    } else if (
      data?.headerAllocatePaymentVO == null &&
      data?.checkPayeeMessage
    ) {
      setWarningAlert(true);
      setWaringMessage(data?.checkPayeeMessage);
      setModalTitle('Warning');
    }
  };
  const handleModalOk = async () => {
    setAlreadyExistInvoiceNum(false);

    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData')) || [];
    const existingTab = window.existingTabToClose;

    if (!existingTab) return; // Prepare destination info

    const newInvoice = existingTab.newTarget.invoiceNumber;
    const newCheck = existingTab.newTarget.checkNumber;
    const destinationPath = `/allocatePaymentDetail/${newCheck}-${newInvoice}`;
    const destinationTitle = `ROSI/PQAS [#${newInvoice}] Check Log #${newCheck}`; // Check for unsaved changes

    const hasUnsavedChanges =
      existingTab &&
      hasUnsavedChangesFor(
        existingTab.invoiceNumber,
        existingTab.checkNumber,
        updateTabs.find((tab) => tab.navTo === existingTab.navTo)
      );

    console.log('hasUnsavedChanges', hasUnsavedChanges);

    if (hasUnsavedChanges) {
      // Mark tab for save and navigation
      updateTabs.forEach((tab) => {
        if (tab.navTo === existingTab.navTo) {
          tab.isSave = true;
          tab.showConfirmClose = true;
          tab.isDirty = true;
          tab.isClosing = true; // Set up the redirect object exactly as expected by DetailScreen
          tab.redirectURLObj = {
            checkLogNum: existingTab.checkNumber, // Current check (to be saved)
            invoiceNum: existingTab.invoiceNumber, // Current invoice (to be saved)
            perviousNavTo: true,
            newCheckLogNum: newCheck, // New check to navigate to
            newInvoiceNum: newInvoice, // New invoice to navigate to
            mfgId:
              existingTab.newTarget?.mfgId || invoiceDetailsByInvoiceNum?.mfgId,
            planType:
              existingTab.newTarget?.planType ||
              invoiceDetailsByInvoiceNum?.rebateProgramCd,
          };
          tab.nextRoute = destinationPath;
          tab.nextTabTitle = destinationTitle;
        }
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs)); // Clear the window reference before navigation

      window.existingTabToClose = null; // Navigate to trigger save dialog in the detail screen

      redirectURLLink(existingTab.navTo, existingTab.tabId, history);
      return; // Exit here - don't continue with the rest of the function
    } // If we reach here, there are no unsaved changes // Handle no unsaved changes case

    updateTabs.forEach((t) => (t.isAlreadyExistInvoiceNum = false));
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));

    if (existingTab) {
      // Close existing tab
      closeTab(existingTab.navTo, history); // Clear redux state

      await dispatch(
        clearReduxAllocatePaymentThirdScreen(
          existingTab.invoiceNumber,
          existingTab.checkNumber,
          history
        )
      ); // Clear header data

      if (
        tabDetails?.[`${existingTab.invoiceNumber}-${existingTab.checkNumber}`]
      ) {
        dispatch(
          dispatchAllocatePaymentHederData(
            (tabDetails[
              `${existingTab.invoiceNumber}-${existingTab.checkNumber}`
            ].closeTab = true),
            existingTab.invoiceNumber,
            existingTab.checkNumber
          )
        );
      } // Clear reference

      window.existingTabToClose = null; // Open new combination - navigate to new tab
      dispatch(setTabDetails(tabDetails));
      const newObj = [];
      newObj.push({
        index: 0,
        invoiceNum: newInvoice,
        checkLogNum: newCheck,
        active: true,
      }); // Set previous screen data

      dispatch(
        setPerviousScreenReduxData({
          ...searchScreenTabData,
          state: {
            ...searchScreenTabData?.state,
            allocateFrom: 'Invoice',
          },
          selectedRow: {
            ...invoiceDetailsByInvoiceNum,
            checkPayeeCdVal: 'MD',
            checkLogNum: newCheck,
          },
        })
      ); // Call ROSI allocation API

      const resultData = await dispatch(
        getRosiAllocatePaymentDetail({
          invoiceNum: newInvoice,
          checkLogNum: newCheck,
          checkPayeeCD: 'MD',
          checkAmt: invoiceDetailsByInvoiceNum?.totInformationalAmt || 0,
          mfgId:
            existingTab.newTarget?.mfgId || invoiceDetailsByInvoiceNum?.mfgId,
          planType:
            existingTab.newTarget?.planType ||
            invoiceDetailsByInvoiceNum?.rebateProgramCd,
        })
      );

      const data = resultData?.headerAllocatePaymentData;
      const headerAllocatePaymentVO = data?.headerAllocatePaymentVO;

      if (
        headerAllocatePaymentVO &&
        Object.keys(headerAllocatePaymentVO)?.length > 0
      ) {
        dispatch(dispatchActiveInvoiceNumber(newObj));
        let newReducer = AllocatePaymentReducer;
        newReducer.headerAllocatePaymentData = tabDetails;
        getAllocatePaymentScreenData(
          data,
          dispatch,
          newReducer,
          history,
          newObj
        );
      } else if (data?.forzenCase) {
        setWarningAlert(true);
        setModalTitle('Warning');
        setWaringMessage(constantMessageData.INVOICE_NUMBER_NOT_FROZEN);
      } else if (data?.noCheckPayeeForInvoice) {
        setWarningAlert(true);
        setModalTitle('Warning');
        setWaringMessage(constantMessageData.CHECK_PAYEE_CODE_INV_NUMBER_MSG);
      } else if (
        data?.headerAllocatePaymentVO == null &&
        data?.checkPayeeMessage
      ) {
        setWarningAlert(true);
        setWaringMessage(data?.checkPayeeMessage);
        setModalTitle('Warning');
      }
    }
  };

  return (
    <>
      <CommonModal
        className="dialog-420"
        data-testid="commonModal1"
        open={warningAlert}
        viewAction
        viewHeader
        onOk={() => setWarningAlert(false)}
        onClose={() => setWarningAlert(false)}
        okTitle="Ok"
        modalTitle={modalTitle}
        childrenComponent={<div className="p-3">{warningMessage}</div>}
      />
      {/* <CommonModal
        className='dialog-420'
        data-testid='sameInvDiffCheckModal'
        open={alreadyExistInvoiceNum}
        viewAction
        viewHeader
        onOk={handleModalOk}
        onClose={() => {
          setAlreadyExistInvoiceNum(false);
          if (window.existingTabToClose) {
            window.existingTabToClose = null;
          }
        }}
        okTitle='Ok'
        closeTitle='No'
        modalTitle={modalTitle}
        childrenComponent={<div className='p-3'>{warningMessage}</div>}
      /> */}
      <CommonModal
        className="dialog-420"
        data-testid="sameInvDiffCheckModal"
        open={alreadyExistInvoiceNum}
        viewAction
        viewHeader
        onOk={handleModalOk}
        onClose={() => {
          setAlreadyExistInvoiceNum(false);
          if (window.existingTabToClose) {
            window.existingTabToClose = null;
          }
        }}
        okTitle="Ok"
        closeTitle="No"
        modalTitle={modalTitle}
        childrenComponent={<div className="p-3">{warningMessage}</div>}
      />
      <CommonModal
        data-testid="checklog-common-modal"
        open={isCheckLogOpen && checkLogDetails?.data?.length > 1}
        viewAction
        viewHeader
        onClose={() => {
          dispatch(setCheckLogOpen(false));
          setAlreadyExistInvoiceNum(false);
          const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
          updateTabs.map((item) => {
            item.isAlreadyExistInvoiceNum = false;
            return item;
          });
          localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
          const newObj = activeInvoiceNumArray || [];
          newObj.splice(newObj?.length - 1, 1);
          dispatch(dispatchActiveInvoiceNumber(newObj));
        }}
        onOk={() => gotoRosiPqas()}
        okTitle="Ok"
        closeTitle="Cancel"
        modalTitle="Choose a Check"
        childrenComponent={
          <InvoiceChecksLog
            sendData={sendData}
            checkLogDetails={checkLogDetails}
          />
        }
      />
      <CommonModal
        data-testid="checklog-common-modal"
        open={isCheckLogOpen && checkLogDetails?.data?.length === 0}
        viewAction
        viewHeader
        onClose={() => dispatch(setCheckLogOpen(false))}
        onOk={() => dispatch(setCheckLogOpen(false))}
        okTitle="Ok"
        modalTitle="Display Invoice"
        childrenComponent="No ROSI/PQAS data available."
        className="dialog-420"
      />
      {!fullScreenView && (
        <>
          <div
            className="tabs-wrapper d-flex justify-content-between"
            style={{ width: '96%' }}
          >
            <div className={classes.root}>
              <AppBar position="static">
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="simple tabs example"
                >
                  <Tab label="Invoice" {...a11yProps(0)} tabIndex={0} />
                  <Tab
                    label="Invoice Quarter"
                    {...a11yProps(1)}
                    disabled={invoiceQuarter?.length === 0}
                    tabIndex={0}
                  />
                  <Tab
                    label="Other Quarter"
                    {...a11yProps(2)}
                    disabled={
                      invoiceOtherQuarter?.wrapperRespVOs === null ||
                      invoiceOtherQuarter?.wrapperRespVOs?.length === 0
                    }
                    tabIndex={0}
                  />
                  <Tab label="Quarter Totals" {...a11yProps(3)} tabIndex={0} />
                  <Tab label="Mailing" {...a11yProps(4)} tabIndex={0} />
                </Tabs>
              </AppBar>
            </div>
            <div
              className="d-flex align-items-center th-icon-group"
              style={{ marginRight: '-10px' }}
            >
              <Action data={invoiceDetailsByInvoiceNum} />
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip id="fullScreen-tooltip">
                    {tabFullScreenView ? 'Minimize Screen' : 'Full Screen'}
                  </Tooltip>
                }
              >
                <div
                  className={
                    tabFullScreenView
                      ? 'th-icon ic-fulScreen-exit'
                      : 'th-icon ic-fulScreen'
                  }
                  role="button"
                  tabIndex="0"
                  data-testid="setFullScreenView"
                  onClick={() => {
                    handleFullScreenView(!tabFullScreenView);
                  }}
                >
                  <span className="ic-title">
                    {' '}
                    {tabFullScreenView ? 'Minimize Screen' : 'Full Screen'}{' '}
                  </span>
                </div>
              </OverlayTrigger>
            </div>
            <div className="clearfix" />
          </div>
          <TabPanel value={value} index={0}>
            <div className="tab-body">
              <form autoComplete="off">
                <div className="tab-holder">
                  <fieldset className="custom-fieldset">
                    <legend>Invoice</legend>
                    <div className="form-wrapper">
                      <div className="mui-custom-form with-select">
                        <TextField
                          label="Create Date"
                          fullWidth
                          id="CreateDate"
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={invoiceDetailsByInvoiceNum?.invoiceCreateDt}
                          inputProps={{
                            maxLength: 50,
                            id: 'CreateDate',
                          }}
                        />
                      </div>
                      <div className="mui-custom-form with-select">
                        <TextField
                          label="AR Issue Found Date"
                          fullWidth
                          id="ARIssue"
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={invoiceDetailsByInvoiceNum?.arIssueFoundDt}
                          inputProps={{
                            maxLength: 50,
                            id: 'ARIssue',
                          }}
                        />
                      </div>
                      <div
                        className={`mui-custom-form with-select frr-text-right ${
                          invoiceDetailsByInvoiceNum?.originalInvoiceQtrAmt !==
                            null &&
                          parseFloat(
                            invoiceDetailsByInvoiceNum?.originalInvoiceQtrAmt
                          ) < 0
                            ? 'negativeValue'
                            : 'positiveValue'
                        }`}
                      >
                        <TextField
                          label="Original Invoice Qtr Amt"
                          fullWidth
                          id="OriginalInvoice"
                          className="text-color-red"
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={currencyFormatter(
                            invoiceDetailsByInvoiceNum?.originalInvoiceQtrAmt,
                            '$'
                          )}
                          inputProps={{
                            maxLength: 50,
                            id: 'OriginalInvoice',
                          }}
                        />
                      </div>
                      <div className="line-break-div" />
                      <div className="mui-custom-form with-select">
                        <TextField
                          label="Freeze Date"
                          fullWidth
                          id="FreezeDate"
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={invoiceDetailsByInvoiceNum?.invoiceFreezeDt}
                          inputProps={{
                            maxLength: 50,
                            id: 'FreezeDate',
                          }}
                        />
                      </div>
                      <div className="mui-custom-form with-select">
                        <TextField
                          label="Last Unit Update Date"
                          fullWidth
                          id="LastUnit"
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={invoiceDetailsByInvoiceNum?.lastUnitUpdateDt}
                          inputProps={{
                            maxLength: 50,
                            id: 'LastUnit',
                          }}
                        />
                      </div>
                      <div
                        className={`mui-custom-form with-select frr-text-right ${
                          invoiceDetailsByInvoiceNum?.totCurrQtrAmt !== null &&
                          parseFloat(
                            invoiceDetailsByInvoiceNum?.totCurrQtrAmt
                          ) < 0
                            ? 'negativeValue'
                            : 'positiveValue'
                        }`}
                      >
                        <TextField
                          label="Current Invoice Qtr Amt"
                          fullWidth
                          id="CurrentInvoiceQtr"
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={currencyFormatter(
                            invoiceDetailsByInvoiceNum?.totCurrQtrAmt,
                            '$'
                          )}
                          inputProps={{
                            maxLength: 50,
                            id: 'CurrentInvoiceQtr',
                          }}
                        />
                      </div>
                      <div className="line-break-div" />
                      <div className="mui-custom-form with-select">
                        <TextField
                          label="Mailed Date"
                          fullWidth
                          id="MailedDate"
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={invoiceDetailsByInvoiceNum?.invoiceMailedDt}
                          inputProps={{
                            maxLength: 50,
                            id: 'MailedDate',
                          }}
                        />
                      </div>
                      <div className="mui-custom-form with-select">
                        <TextField
                          label="Excluded NDC Update Date"
                          fullWidth
                          id="ExcludedNDC"
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={
                            invoiceDetailsByInvoiceNum?.excludedNdcUpdateDt
                          }
                          inputProps={{
                            maxLength: 50,
                            id: 'ExcludedNDC',
                          }}
                        />
                      </div>
                      <div
                        className={`mui-custom-form with-select frr-text-right ${
                          invoiceDetailsByInvoiceNum?.invoiceBalance !== null &&
                          parseFloat(
                            invoiceDetailsByInvoiceNum?.invoiceBalance
                          ) < 0
                            ? 'negativeValue'
                            : 'positiveValue'
                        }`}
                      >
                        <TextField
                          label="Current Invoice Qtr Balance"
                          fullWidth
                          id="CurrentInvoiceBal"
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={currencyFormatter(
                            invoiceDetailsByInvoiceNum?.invoiceBalance,
                            '$'
                          )}
                          inputProps={{
                            maxLength: 50,
                            id: 'CurrentInvoiceBal',
                          }}
                        />
                      </div>
                      <div className="line-break-div" />
                      <div className="mui-custom-form with-select">
                        <TextField
                          label="Distributed Date"
                          fullWidth
                          id="DistributedDate"
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={
                            invoiceDetailsByInvoiceNum?.invoiceDistributedDt
                          }
                          inputProps={{
                            maxLength: 50,
                            id: 'DistributedDate',
                          }}
                        />
                      </div>
                      <div className="mui-custom-form with-select">
                        <TextField
                          label="Handling Code"
                          fullWidth
                          id="HandlingCode"
                          select
                          placeholder=""
                          disabled={
                            invoiceDetailsByInvoiceNum?.invoiceFreezeDt !=
                              null ||
                            invoiceDetailsByInvoiceNum?.invoiceUnderThresholdInd !==
                              1
                          }
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="invoiceHandlingCd"
                          value={
                            saveRequestData?.invoiceHandlingCd
                              ? saveRequestData.invoiceHandlingCd
                              : invoiceDetailsByInvoiceNum?.invoiceHandlingCd
                          }
                          onChange={(e) => handleInvoiceChangeValues(e)}
                          inputProps={{
                            maxLength: 50,
                            id: 'HandlingCode',
                          }}
                        >
                          <MenuItem selected key="Please Select One" value="-1">
                            Please Select One
                          </MenuItem>
                          {handlingCodeValues &&
                          handlingCodeValues.length &&
                          handlingCodeValues.length > 0
                            ? handlingCodeValues.map((item) => {
                                return (
                                  <MenuItem
                                    selected
                                    key={item.codeValueID.codeValue}
                                    value={item.codeValueID.codeValue}
                                    disabled={
                                      item.codeValueID.codeValue === 'F' &&
                                      defForgiveReqCommentInd &&
                                      !ccCommentsExist
                                    }
                                  >
                                    {item.shortDescription}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </TextField>
                      </div>
                      <div
                        className={`mui-custom-form with-select frr-text-right ${
                          invoiceDetailsByInvoiceNum?.totUnitChangesAmt !==
                            null &&
                          parseFloat(
                            invoiceDetailsByInvoiceNum?.totUnitChangesAmt
                          ) < 0
                            ? 'negativeValue'
                            : 'positiveValue'
                        }`}
                        style={{ textAlign: 'right' }}
                      >
                        <TextField
                          label="Original Invoice Unit Change Amt"
                          fullWidth
                          placeholder=""
                          id="OriginalChangeAmt"
                          classes="txt-right"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={currencyFormatter(
                            invoiceDetailsByInvoiceNum?.totUnitChangesAmt,
                            '$'
                          )}
                          inputProps={{
                            maxLength: 50,
                            textAlign: 'right',
                            id: 'OriginalChangeAmt',
                          }}
                        />
                      </div>
                      <div className="line-break-div" />
                      <div className="mui-custom-form with-select">
                        <TextField
                          label="Uploaded Date"
                          fullWidth
                          id="UploadedDate"
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={invoiceDetailsByInvoiceNum?.invoiceUploadedDt}
                          inputProps={{
                            maxLength: 50,
                            id: 'UploadedDate',
                          }}
                        />
                      </div>
                      <div className="mui-custom-form with-select">
                        <TextField
                          label="Invoice Status"
                          fullWidth
                          id="InvoiceStatus"
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={invoiceDetailsByInvoiceNum?.invoiceStatusCd}
                          inputProps={{
                            maxLength: 50,
                            id: 'InvoiceStatus',
                          }}
                        />
                      </div>
                      <div
                        className={`mui-custom-form with-select frr-text-right ${
                          invoiceDetailsByInvoiceNum?.totInformationalAmt !==
                            null &&
                          parseFloat(
                            invoiceDetailsByInvoiceNum?.totInformationalAmt
                          ) < 0
                            ? 'negativeValue'
                            : 'positiveValue'
                        }`}
                      >
                        <TextField
                          label="Original Invoice Informational Amt"
                          fullWidth
                          placeholder=""
                          id="OriginalInformation"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={currencyFormatter(
                            invoiceDetailsByInvoiceNum?.totInformationalAmt,
                            '$'
                          )}
                          inputProps={{
                            maxLength: 50,
                            id: 'OriginalInformation',
                            className: classes.input,
                          }}
                        />
                      </div>
                      <div className="line-break-div" />
                      <div className="mui-custom-form with-select">
                        <div
                          className="form-wrapper vertical-wrapper"
                          style={{ marginLeft: '-16px' }}
                        >
                          <div
                            className="mui-custom-form no-margin min-md"
                            style={{ paddingLeft: '305px' }}
                          >
                            <div
                              className="sub-radio text-black sub-label"
                              style={{ marginLeft: '-289px' }}
                            >
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    color="primary"
                                    checked={
                                      invoiceDetailsByInvoiceNum?.invoiceUnderThresholdInd
                                    }
                                    disabled
                                  />
                                }
                                label="Under Threshold"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mui-custom-form with-select">
                        <div
                          className="form-wrapper vertical-wrapper"
                          style={{ marginLeft: '-16px' }}
                        >
                          <div
                            className="mui-custom-form no-margin min-md"
                            style={{ paddingLeft: '320px' }}
                          >
                            <div
                              className="sub-radio text-black sub-label"
                              style={{ marginLeft: '-304px' }}
                            >
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    color="primary"
                                    checked={
                                      invoiceDetailsByInvoiceNum?.auditsExist
                                    }
                                    disabled
                                  />
                                }
                                label="Audits Exist"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mui-custom-form with-select">
                        <div className="form-wrapper vertical-wrapper">
                          <div
                            className="mui-custom-form no-margin min-md"
                            style={{ paddingLeft: '300px' }}
                          >
                            <div
                              className="sub-radio text-black sub-label"
                              style={{ marginLeft: '-283px' }}
                            >
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    color="primary"
                                    checked={
                                      !!(
                                        saveRequestData?.holdForInvestigationInd &&
                                        saveRequestData?.holdForInvestigationInd ===
                                          1
                                      )
                                    }
                                    name="holdForInvestigationInd"
                                    onChange={(e) => {
                                      handleInvoiceChangeValues(e);
                                    }}
                                    disabled={
                                      isEnablebyRole ||
                                      invoiceDetailsByInvoiceNum?.invoiceFreezeDt !=
                                        null
                                    }
                                  />
                                }
                                label="Hold for Investigation"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>
                {invoiceDetailsByInvoiceNum?.currInEffectInd == 1 && (
                  <div className="tab-holder" style={{ marginTop: '20px' }}>
                    <fieldset className="custom-fieldset">
                      <legend>UnAllocated Balance</legend>
                      <div className="form-wrapper">
                        <div className="mui-custom-form with-select">
                          <TextField
                            label="Type"
                            fullWidth
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            disabled
                            value={typeCode}
                            inputProps={{
                              maxLength: 50,
                            }}
                          />
                        </div>
                        <div className="mui-custom-form with-select frr-text-right">
                          <TextField
                            label="Amount"
                            fullWidth
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            disabled
                            value={`$ ${invoiceDetailsByInvoiceNum?.unallocatedBalanceAmt}`}
                            inputProps={{
                              maxLength: 50,
                            }}
                          />
                        </div>
                      </div>
                    </fieldset>
                  </div>
                )}
              </form>
            </div>
          </TabPanel>
        </>
      )}
      <TabPanel value={value} index={1}>
        <InvoiceQuarterTab
          invoiceDetailsByInvoiceNum={invoiceDetailsByInvoiceNum}
          invoiceQuarter={invoiceQuarter}
          setFullScreenView={setFullScreenView}
          fullScreenView={fullScreenView}
        />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <InvoiceOtherQuarterTab
          invoiceDetailsByInvoiceNum={invoiceDetailsByInvoiceNum}
          setFullScreenView={setFullScreenView}
          fullScreenView={fullScreenView}
          commonDropdownList={commonDropdownList}
          invoiceReasonList={invoiceReasonList}
        />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <InvoiceQuarterTotalsTab
          invoiceDetailsByInvoiceNum={invoiceDetailsByInvoiceNum}
          setFullScreenView={setFullScreenView}
          fullScreenView={fullScreenView}
        />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <MailingTab invoiceDetailsByInvoiceNum={invoiceDetailsByInvoiceNum} />
      </TabPanel>
    </>
  );
}
